import type { PlatformConnectionRetentionRow } from './PlatformConnectionRetention'
import { Badge, type BadgeProps } from '@/components/ui/badge'

export interface ConnectionSummary {
  connections?: PlatformConnectionRetentionRow[]
  active_count: number
  needs_attention_count: number
  failing_count: number
  needs_attention_since: string | null
}

export function PlatformConnectionSummary({ summary }: { summary?: ConnectionSummary }) {
  const connectionSummary = summary ?? {
    active_count: 0,
    needs_attention_count: 0,
    failing_count: 0,
    needs_attention_since: null,
  }
  let label = 'Healthy'
  let variant: BadgeProps['variant'] = 'success'
  if (connectionSummary.active_count === 0) {
    label = 'None'
    variant = 'neutral'
  } else if (connectionSummary.needs_attention_count > 0) {
    label = 'Needs attention'
    variant = 'warning'
  } else if (connectionSummary.failing_count > 0) {
    label = 'Failing'
    variant = 'destructive'
  }

  return (
    <span className="inline-flex items-center gap-2 whitespace-nowrap">
      <Badge variant={variant}>{label}</Badge>
      <span className="text-body-sm text-muted-foreground">
        {connectionSummary.active_count} active
      </span>
    </span>
  )
}
